import { render, staticRenderFns } from "./barcode.vue?vue&type=template&id=3155b335&scoped=true"
import script from "./barcode.vue?vue&type=script&lang=js"
export * from "./barcode.vue?vue&type=script&lang=js"
import style0 from "./barcode.vue?vue&type=style&index=0&id=3155b335&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3155b335",
  null
  
)

export default component.exports